import { XMarkIcon } from '@heroicons/react/24/outline';

// Shared chrome for the dismissible cards pinned to the bottom of AppSidebar:
// SidebarMessage's welcome/CTA cards and the BTS tip card. Owns the card shell +
// close button so those consumers only supply their content. `headerActions`
// lets a consumer (the BTS card's tip-nav chevrons) sit left of the close X;
// the top-right controls stay above a full-card click target via z-10.
export const SidebarCard = ({ onDismiss, headerActions, largeControls = false, children }) => (
  <div className='relative mx-1 mb-3 bg-white border border-gray-200 rounded-xl px-3 pt-5 pb-5 animate-sidebar-banner-in'>
    {/* Controls are absolutely positioned, so growing the hit area (largeControls
        → more padding) can't shift the card's content layout. The icon itself
        stays 16px; only the hoverable button grows (to 24px). */}
    <div className='absolute top-2 right-2 z-10 flex items-center gap-0.5'>
      {headerActions}
      <button
        type='button'
        onClick={onDismiss}
        aria-label='Close'
        className={`${largeControls ? 'p-1' : 'p-0.5'} rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors`}>
        <XMarkIcon className='h-4 w-4' />
      </button>
    </div>
    {children}
  </div>
);
